import type { LayoutType } from '../../../types';

interface GetFinalRatioProps {
  layout: LayoutType;
  settingsRatio: number | undefined;
  ratio: number | undefined;
  isInPopup: boolean;
}

export const getFinalRatio = ({
  layout,
  settingsRatio,
  ratio,
  isInPopup
}: GetFinalRatioProps) => {
  if (isInPopup) {
    return;
  }

  const derivedRatio = settingsRatio || ratio;

  return {
    grid: derivedRatio,
    list: ratio,
    carousel: derivedRatio,
    slider: ratio,
    masonry: undefined
  }[layout];
};
